
import { BusinessUnitEmailContactEntityDecorator } from './business-unit-email-contact.decorator';
import { BusinessUnitEmailContact } from './business-unit-email-contact.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class BusinessUnitEmailContactTypeInfoBase implements CrudTypeInfo<BusinessUnitEmailContact, number> {
  name = 'Business Unit Email Contact';
  entityDecorator = new BusinessUnitEmailContactEntityDecorator();
  
  createAuthorities = ['WRITE_BUSINESS_UNIT_EMAIL_CONTACT'];
  editAuthorities = ['WRITE_BUSINESS_UNIT_EMAIL_CONTACT'];
  deleteAuthorities = ['WRITE_BUSINESS_UNIT_EMAIL_CONTACT'];
  viewAuthorities = ['READ_BUSINESS_UNIT_EMAIL_CONTACT'];
  
  searchRouteBase = ['/businessunitemailcontact/search'];
  createRouteBase = ['/businessunitemailcontact/create'];
  editRouteBase = ['/businessunitemailcontact/edit'];
  viewRouteBase = ['/businessunitemailcontact/view'];
  
  description(item: BusinessUnitEmailContact): string {
    return '' +  item.businessUnitEmailContactId +  ' - ' +  item.description;
  }
}



